<template>
	<div class="right-top" :class="{ scrolled: isScrolled }">
		<!-- 右侧顶部内容 -->
		<div class="right-top-nav">
			<div class="right-top-nav-model" @click="gotoLink()">首页</div>
			<div class="right-top-nav-model" @click="gotoLink('About')">关于我们</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'

	export default {
		name: 'RightTop',
		components: {

			
		},
		data() {
			return {
				isScrolled: false,
			};
		},
		methods: {
			gotoLink(url) {
				this.$router.push({
					name: url
				})
			},
			handleScroll() {
				this.isScrolled = window.scrollY > 0;
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		}
	}
</script>

<style>
	.right-top {
		/* Logo */

		position: fixed;
		width: 100%;
		height: 60px;
		/* right: 0px; */

		top: 0px;
		z-index: 99;

		/* 右边留点间距 */
		/* background-color: #F5F7FC; */
		background: transparent;
		backdrop-filter: none;


	}
	
	.right-top.scrolled {
		/* background: white !important; */
		background-color: #F5F7FC !important; /* ✅ 把背景色从 header-container 提到这里 */
		backdrop-filter: blur(25px) !important;         /* ✅ 背景模糊也提上来 */
	}

	.right-top-nav {
		/* tabs */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;

		position: absolute;
		width: 272px;
		height: 60px;
		top: 1px;
		margin-left: 240px;
		/* left: 20px; */
	}

	.right-top-nav-model {
		/* tabs/line */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 10px 16px;
		box-sizing: border-box;
		isolation: isolate;

		/* width: 112px; */
		height: 42px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;



		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 140%;
		/* or 22px */
		text-align: center;

		/* 文字/text-5 */
		color: #1D2129;

	}

	.right-top-nav-model:hover {
		cursor: pointer;
		color: #2459E5;
	}
</style>